export const FACILITY_MANAGEMENT = 'FACILITY_MANAGEMENT';
export const SERVICE_MANAGEMENT = 'SERVICE_MANAGEMENT';
export const RESOURCE_MANAGEMENT = 'RESOURCE_MANAGEMENT';
export const BUSINESS_MANAGEMENT = 'BUSINESS_MANAGEMENT';
export const PARTNER_MANAGEMENT = 'PARTNER_MANAGEMENT';
export const PARTNER_INVITE = 'PARTNER_INVITE';
export const PERMISSION_MANAGEMENT = 'PERMISSION_MANAGEMENT';
export const CLIENT_MANAGEMENT = 'CLIENT_MANAGEMENT';